import { ReactNode } from "react"
import { Redirect } from "react-router-dom"

import { defaultRedirectRoute, redirecturlQueryParam } from "../../app/constants/constants"
import useURLQuery from "../../hooks/useURLQuery"
import LoadingUpAnimation from "../LoadingUpAnimation"
import { useUpAuth } from "./UpAuth"

const SignInContainer = ({ children }: { children: ReactNode }) => {

  const { isAuthenticated, upAuthLoading } = useUpAuth()
  const searchParams = useURLQuery();
  const redirecturl = searchParams.get(redirecturlQueryParam);


  if (upAuthLoading) {
    return <LoadingUpAnimation />
  }

  if (isAuthenticated) {
    return <Redirect to={redirecturl ?? defaultRedirectRoute} />
  }

  return <div>
    {children}
  </div>

}

export default SignInContainer